import React from 'react';

import { Icon } from '../icons';

export const CopyIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.13581 9H4.13333C2.95513 9 2 9.95513 2 11.1333V29.8667C2 31.0449 2.95512 32 4.13333 32H20.4099C21.5881 32 22.5432 31.0449 22.5432 29.8667V25H18.8099V28.2667H5.73333V12.7333H7.13581V9Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9235 3.73333V19.2667H26V3.73333H12.9235ZM11.3235 0C10.1453 0 9.19016 0.955126 9.19016 2.13333V20.8667C9.19016 22.0449 10.1453 23 11.3235 23H27.6C28.7782 23 29.7334 22.0449 29.7334 20.8667V2.13333C29.7334 0.955126 28.7782 0 27.6 0H11.3235Z"
        />
      </g>
    </svg>
  );
};
